import { BASE_JOB_API, REPORT_JOBS_API, SEARCH_JOBS_API, BASE_JOB_V2_API } from '~/constants/APIs'
import { JobReponseData, JobSearchRequest } from '~/models'
import axiosClient from './axiosClient'

export const jobApis = {
  searchJobs: (params: JobSearchRequest | null) =>
    axiosClient.get(SEARCH_JOBS_API, { params }) as unknown as JobReponseData,
  downloadJobPhotos: (jobId: number) =>
    axiosClient.get(BASE_JOB_API + jobId + '/Photos', { responseType: 'blob' }),
  downloadProgrammingLog: (jobId: number) =>
    axiosClient.get(BASE_JOB_API + jobId + '/ProgrammingLog', { responseType: 'blob' }),
  uploadJobPhotos: (jobId: number) => axiosClient.post(BASE_JOB_V2_API + jobId + '/Photos'),
  reportJobs: (params: JobSearchRequest | null) =>
    axiosClient.get(REPORT_JOBS_API, { params, responseType: 'blob' })
}
